import i18n from "../../../../utils/ChrI18n";
import { cookieTypeKeys } from "../constants";

export const cookieTypes = [
  {
    id: 1,
    title: i18n.t("feature.cookie_consent.header.Necessary"),
    description: i18n.t("feature.cookie_consent.content.necessary_cookies_description"),
    isEditable: false,
    key: cookieTypeKeys.necessary
  },
  {
    id: 2,
    title: i18n.t("feature.cookie_consent.header.Analytics"),
    description: i18n.t("feature.cookie_consent.content.analytics_cookies_description"),
    isEditable: true,
    key: cookieTypeKeys.analytics
  }
];

export const editableCookieTypeKeys = cookieTypes.filter(cookie => cookie.isEditable).map(cookie => cookie.key);